module.exports = __webpack_public_path__ + "static/media/viaMEDIAlogo01.f23ff28e.png";